import React, { Component, useState, useEffect, useRef } from "react";
import "../index.css";
import "./index.css";
import { MDBRow, MDBCol } from "mdbreact";
import { NavLink, withRouter } from "react-router-dom";
import { AiOutlinePlus } from "react-icons/ai";

const Questions = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [playing, setPlaying] = useState(false);
  const [iconVisible, setIconVisible] = useState(true);
  const [openIndex, setOpenIndex] = useState(null);
  const videoRef = useRef();

  const faqs = [
    {
      question: "What is DarkGen?",
      answer:
        "DarkGen is a cutting-edge service that creates personalized video messages from your favorite celebrities. Utilizing advanced AI technology, we generate custom videos that make it feel like your chosen celebrity is speaking directly to you. It's a unique way to experience a more personal connection with celebrities, delivered to you in just a few minutes.",
    },
    {
      question: "How does DarkGen work?",
      answer:
        "To create your personalized video, simply select your celebrity and submit any specific message. Our AI technology then crafts a video message that captures the essence of your chosen celebrity, complete with their likeness and voice. The process is quick and easy, ensuring you receive a high-quality, personalized video in just a few minutes.",
    },
    {
      question: "How long does it take to receive my video?",
      answer:
        "Our service is designed for speed and efficiency. Once you place your order, our AI system gets to work and you can expect to receive your custom video within a few minutes. This quick turnaround time makes DarkGen perfect for last-minute gifts or surprises.",
    },
    {
      question: "How much does a custom video cost?",
      answer:
        "Each custom video from DarkGen is priced at 1 credit. You can purchase a bundle of credits by clicking the 'Add video credits' button at the top of this page. Generally 1 credit costs about $1. This cost includes the personalized message from your selected celebrity and the quick delivery within a few minutes. Our pricing is set to ensure accessibility for all fans while providing a unique and memorable experience.",
    },
    {
      question: "Can I choose any celebrity for my video?",
      answer:
        "Absolutely! You have the freedom to select any celebrity for the video. Whether it's Beyonce, Taylor Swift or Donald Trump, you can choose your favorite to be the star of your personalized message.",
    },
    {
      question: "Is the video message really in the celebrities voice?",
      answer:
        "Yes, our AI technology synthesizes the voice of your chosen celebrity to create a realistic and authentic-sounding message. We strive to capture the essence of each celebrity's unique voice style, making your video message a truly special experience.",
    },
    {
      question: "Can I share my video on social media?",
      answer:
        "Definitely! We encourage you to share your custom video on social media platforms. It's a great way to show off the unique message you received. Just be sure to tag us or use our hashtag #DarkGen",
    },
    {
      question: "What if I’m not satisfied with my video?",
      answer:
        "Your satisfaction is our top priority. If you're not happy with the video you receive, please contact our customer support team. We'll work with you to address any concerns and ensure you have a positive experience with our service.",
    },
    {
      question: "Is DarkGen officially affiliated with any celebrities?",
      answer:
        "No, DarkGen is an independent service and is not officially affiliated with any celebrities. This is purely for parody and entertainment purposes. Our service is designed for entertainment purposes, offering fans a novel way to feel connected to their favorite celebrities.",
    },
    {
      question: "How can I pay for my video?",
      answer:
        "We accept various payment methods, including credit/debit cards, PayPal, and other digital wallets. The payment process is secure and user-friendly, ensuring a smooth transaction for your custom video order.",
    },
  ];

  const toggleOpen = (index) => {
    if (index === openIndex) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };

  const handleMouseEnter = (item) => {
    setCurrentItem(item);
    const video = videoRef.current;
    if (video) {
      video.play();
    }
  };

  const handleMouseLeave = () => {
    const video = videoRef.current;
    if (video) {
      video.pause();
      video.currentTime = 0; // Rewind the video to the beginning when pausing
      setCurrentItem(null);
    }
  };

  return (
    <>
      <MDBRow
        style={{
          marginTop: 0,
          paddingTop: 0,
          paddingBottom: 10,
        }}
      >
        <MDBCol className="d-flex justify-content-center" size="12">
          <MDBRow
            style={{
              marginTop: 10,
              width: "100%",
              backgroundColor: "#201e23",
              borderRadius: 10,
              paddingBottom: 50,
              overflowY: "hidden",
            }}
          >
            <MDBCol className="d-flex justify-content-start" size="12">
              <MDBRow style={{ marginTop: 40 }}>
                {faqs.map((faq, index) => (
                  <>
                    <MDBCol
                      key={faq.question}
                      className="d-flex justify-content-start"
                      size="12"
                      style={{ paddingBottom: 0, paddingTop: 0 }}
                    >
                      <div
                        onClick={() => toggleOpen(index)}
                        style={{
                          color: "white",
                          fontFamily: "CSMedium",
                          fontSize: 18,
                          marginLeft: 30,
                          lineHeight: 1,
                          opacity: 1,
                          cursor: "pointer",
                          userSelect: "none",
                          paddingTop: 5,
                          paddingBottom: 26,
                          width: "90%",
                        }}
                        className="d-flex justify-content-between"
                      >
                        <p>{faq.question}</p>{" "}
                        <div
                          style={{
                            height: 30,
                            width: 30,
                            backgroundColor: "white",
                            borderRadius: 100,
                            marginTop: -10,
                          }}
                          className="d-flex justify-content-center"
                        >
                          <AiOutlinePlus
                            style={{ color: "#30312c", marginTop: 5 }}
                          />
                        </div>
                      </div>
                    </MDBCol>
                    <MDBCol
                      className="d-flex justify-content-start"
                      size="12"
                      style={{
                        paddingBottom: 0,
                        paddingTop: 0,
                      }}
                    >
                      <div
                        style={{
                          color: "white",
                          fontFamily: "CSRegular",
                          fontSize: 15,
                          marginTop: openIndex === index ? -14 : 0,
                          marginLeft: 30,
                          lineHeight: 1.6,
                          opacity: 0.7,
                          borderBottom: "1px solid grey",
                          width: "90%",
                          marginBottom: 40,
                          paddingBottom: openIndex === index ? 50 : 0,
                        }}
                      >
                        {openIndex === index && <div>{faq.answer}</div>}
                      </div>
                    </MDBCol>
                  </>
                ))}
              </MDBRow>
            </MDBCol>
          </MDBRow>
        </MDBCol>
      </MDBRow>
    </>
  );
};

export default withRouter(Questions);
